import React from 'react';
import Input from '../../../components/ui/Input';
import { cn } from '../../../utils/cn';

const WaterVolumeInput = ({ value, onChange }) => {
  const units = ['ml', 'IU'];

  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-foreground block">
        Water Volume
      </label>
      <div className="flex items-center gap-3">
        <Input
          type="number"
          value={value?.value}
          onChange={(e) => onChange({ ...value, value: e?.target?.value })}
          placeholder="0"
          min="0"
          step="0.1"
          className="flex-1"
        />
        <div className="flex gap-2">
          {units?.map((unit) => (
            <button
              key={unit}
              onClick={() => onChange({ ...value, unit })}
              className={cn(
                "px-4 py-2 rounded-lg border-2 transition-all font-medium",
                value?.unit === unit
                  ? "border-primary bg-primary text-primary-foreground"
                  : "border-border bg-card text-foreground hover:border-primary/50"
              )}
            >
              {unit}
            </button>
          ))}
        </div>
      </div>
      <p className="text-xs text-muted-foreground">
        Enter volume in milliliters (mL) or International Units (IU)
      </p>
    </div>
  );
};

export default WaterVolumeInput;